import TimeAgo from 'javascript-time-ago';
import { SUPPORTED_LOCALES } from '../i18n';

export const timeago = (timestamp: number, locale?: string): string =>
  new TimeAgo(locale ?? SUPPORTED_LOCALES[0]).format(timestamp, 'round');
